/**
 * Animação do Banner - Fade In
 * Controla a animação de fade-in do logo e texto do banner quando a página carrega
 */

export default function initBannerAnimation() {
    function startAnimation() {
        const logo = document.querySelector("#banner .logo");
        const content = document.querySelector("#banner .content");
        const contentBottom = document.querySelector("#banner .content-bottom");

        if (!logo || !content || !contentBottom) {
            console.warn("Elementos do banner não encontrados");
            return;
        }

        logo.offsetHeight;
        content.offsetHeight;
        contentBottom.offsetHeight;

        function animateElements() {
            logo.classList.add("animate");

            setTimeout(() => {
                content.classList.add("animate");
            }, 200);

            setTimeout(() => {
                contentBottom.classList.add("animate");
            }, 500);
        }

        setTimeout(animateElements, 100);
    }

    setTimeout(startAnimation, 200);
}
